<div class="layout-topbar">
    <div class="layout-topbar-logo-container">
        <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>
    </div>

    <div class="layout-topbar-actions">
        <div class="layout-config-menu">
            @if (mostrarNotificaciones) {
                <app-notificaciones />
            }
            <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                <i
                    [ngClass]="{
                        'pi ': true,
                        'pi-moon': layoutService.isDarkTheme(),
                        'pi-sun': !layoutService.isDarkTheme()
                    }"
                ></i>
            </button>
            <div class="relative">
                <button
                    class="layout-topbar-action layout-topbar-action-highlight"
                    pStyleClass="@next"
                    enterFromClass="hidden"
                    enterActiveClass="animate-scalein"
                    leaveToClass="hidden"
                    leaveActiveClass="animate-fadeout"
                    [hideOnOutsideClick]="true"
                >
                    <i class="pi pi-palette"></i>
                </button>
                <app-configurator />
            </div>
        </div>

        @if (userAuth) {
            <div class="topbar-user-divider"></div>

            <button
                type="button"
                class="topbar-user"
                pTooltip="Foto de perfil"
                tooltipPosition="bottom"
                (click)="photoUrl ? openPhotoModal() : triggerFileInput()"
            >
                <span class="topbar-user-avatar" [class.topbar-user-avatar--uploading]="isUploading">
                    @if (isUploading) {
                        <i class="pi pi-spin pi-spinner"></i>
                    } @else if (photoUrl) {
                        <img [src]="photoUrl" alt="Foto de perfil" class="topbar-user-avatar-img" />
                    } @else {
                        <span>{{ userAuth.nombre | slice: 0 : 1 }}</span>
                    }
                </span>
                <span class="topbar-user-info">
                    <span class="topbar-user-name">{{ userAuth.nombre }}</span>
                    <span class="topbar-user-meta"
                        >{{ userAuth.entidad }}{{ userAuth.sede ? ' - ' + userAuth.sede : '' }}</span
                    >
                </span>
            </button>

            <button type="button" pButton icon="pi pi-sign-out" label="Salir" class="topbar-logout" (click)="logout()"></button>
        }
    </div>
</div>

<input #fileInput type="file" accept="image/*" class="hidden" (change)="onFileSelected($event)" />

<p-dialog
    header="Foto de perfil"
    [modal]="true"
    [(visible)]="showPhotoModal"
    [style]="{ width: '22rem' }"
    [breakpoints]="{ '640px': '90vw' }"
    [draggable]="false"
    [resizable]="false"
>
    <div class="photo-modal-body">
        @if (isUploading) {
            <div class="photo-modal-spinner">
                <p-progressSpinner strokeWidth="4" animationDuration=".8s" />
                <span class="photo-modal-spinner-label">Subiendo foto...</span>
            </div>
        } @else {
            <img [src]="photoUrl" alt="Foto de perfil" class="photo-modal-img" />
            <p-button
                label="Cambiar foto"
                icon="pi pi-camera"
                [outlined]="true"
                severity="secondary"
                styleClass="photo-modal-btn"
                (click)="triggerFileInput()"
            />
        }
    </div>
</p-dialog>

<p-toast />
